import TransportationIcon from './ServicesIcon';
export default TransportationIcon;
